const styles = {
  wrapper: 'flex flex-col',
  videoInfo: 'pt-2 md:pt-6 md:w-10/12 md:mx-auto',
};

export default styles;
